import { Rutas } from '@/constants/rutas';

export const NavigationFantasyKaosItems = [
    {
        title: 'Pizarra',
        shortTitle: 'Pizarra',
        path: Rutas.FANTASY_KAOS_PIZARRA,
    },
    {
        title: 'Presidentes',
        shortTitle: 'Presidentes',
        path: Rutas.FANTASY_KAOS_PRESIDENTES,
    },
    {
        title: 'Reglas',
        shortTitle: 'Reglas',
        path: Rutas.FANTASY_KAOS_REGLAS,
    },
    {
        title: 'Managers',
        shortTitle: 'Managers',
        path: Rutas.FANTASY_KAOS_MANAGERS,
    },
    {
        title: 'Ranking de Presidentes',
        shortTitle: 'Ranking de Presidentes',
        path: Rutas.FANTASY_KAOS_RANKING_DE_PRESIDENTES,
    },
    {
        title: 'Sorteo',
        shortTitle: 'Sorteo',
        path: Rutas.FANTASY_KAOS_SORTEO,
    }
];
